import React, { useEffect, useState } from 'react';
import { UserPlatformLogsFilter } from './UserPlatformLogsFilter';
import { UserService } from '../UserService';
import { UserPlatformsLogs } from '../../../model/user/UserPlatformsLogs';
import { Card, Table } from 'react-bootstrap';
import { formatDate } from '../../../utils/Functions';
import { ImpersonateEye } from '../../../shared/components/ImpersonateEye';
import { ErrorToast } from '../../../utils/toasters';
import TableLayout from '../../../shared/layout/table/TableLayout';
import { ITableColumn } from '../../../shared/components/TableSkeleton';

const USER_PLATFORM_LOGS_COLUMNS: ITableColumn[] = [
    { label: 'UserID' },
    { label: 'Handle' },
    { label: 'Email' },
    { label: 'Followers' },
    { label: 'Platform' },
    { label: 'is Manual?' },
    { label: 'Date', className: 'text-right' },
];

export function UserPlatformLogsList() {
    const [change, setChange] = useState(false);
    const [dataLoading, setDataLoading] = useState(true);
    const [logs, setLogs] = useState<UserPlatformsLogs[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [state, setState] = useState({
        page: 1,
        perPage: 15,
        userId: '',
        platformId: '',
        from: '',
        to: '',
        handle: '',
    });

    useEffect(() => {
        let isCurrent = true;
        setDataLoading(true);

        UserService.getUserPlatformLogs(state)
            .then(data => {
                if (!isCurrent) return;
                setLogs(data.data);
                setTotalPages(Math.ceil(data.count / state.perPage));
            })
            .catch(err => {
                if (isCurrent) ErrorToast(err);
            })
            .finally(() => {
                if (isCurrent) setDataLoading(false);
            });

        return () => {
            isCurrent = false;
        };
    }, [change]);

    function handleClick() {
        setState({ ...state, page: 1 });
        setChange(!change);
    }

    function handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = evt.target;
        setState({
            ...state,
            [name]: value.replace(/^@/, ''), // remove @ on first place
        });
    }

    const handlePages = (updatePage: number) => {
        setState({ ...state, page: updatePage });
        setChange(!change);
    };

    return (
        <>
            <Card
                className="mb-5 p-4"
                onKeyDown={(e: any) => {
                    if (e.key === 'Enter') handleClick();
                }}
            >
                <UserPlatformLogsFilter
                    handleChanges={handleChange}
                    handleClick={handleClick}
                    state={state}
                    setState={setState}
                />
            </Card>

            <TableLayout
                pagination={{ page: state.page, totalPages }}
                listLength={logs.length}
                handlePages={handlePages}
                isLoading={dataLoading}
                dataName="logs"
                skeletonColumns={USER_PLATFORM_LOGS_COLUMNS}
                skeletonRows={state.perPage}
            >
                <Table responsive className="table align-middle table-row-dashed fs-7 gy-5 dataTable no-footer">
                    <thead>
                        <tr className="even">
                            {USER_PLATFORM_LOGS_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {logs?.map(item => (
                            <tr key={item.id}>
                                <td>{item?.user?.id}</td>
                                <td>{item.title ?? '-'}</td>
                                <td>
                                    <ImpersonateEye id={item?.user?.id ?? 0} />
                                    {item?.user?.email}
                                </td>
                                <td>{item?.followers}</td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <img
                                            width="30"
                                            height="30"
                                            src={item?.mainPlatform?.path}
                                            alt="main platform"
                                        />
                                        <h6 className="mb-0 ml-2">{item?.mainPlatform?.name}</h6>
                                    </div>
                                </td>
                                <td>{String(item?.manualUserInput ?? false)}</td>
                                <td className="text-right">
                                    {item.audienceDataUpdatedAt
                                        ? formatDate(item.audienceDataUpdatedAt as string)
                                        : '-'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </TableLayout>
        </>
    );
}
